import type { Transition, Variants } from "motion/react";

import { MOTION_EASE_STANDARD, UI_TRANSITION_SECONDS } from "@ryde/shared";

export const MODAL_DIALOG_FILL_CONTENT_HEIGHT_CLASS =
  "modal-dialog-fill-content-height" as const;

export const MODAL_DIALOG_ENTRY_VARIANTS: Variants = {
  hidden: { opacity: 0, x: "-50%", y: "calc(-50% + 14px)", scale: 0.98 },
  visible: { opacity: 1, x: "-50%", y: "-50%", scale: 1 },
};

export const MODAL_DIALOG_ENTRY_TRANSITION: Transition = {
  duration: UI_TRANSITION_SECONDS.modalEntry,
  ease: [...MOTION_EASE_STANDARD],
};
